TrelloModel = require 'models/internal/trello-model'
Util = require 'lib/util'
parseURL = require 'url-parse'
_ = require 'underscore'

module.exports = class Attachment extends TrelloModel
  typeName: 'Attachment'
  urlRoot: -> "#{ @getCard().url() }/attachments"

  getCard: -> @collection.sourceModel
  editable: -> @getCard().editable()

  smallestPreviewBiggerThan: (width, height) ->
    Util.smallestPreviewBiggerThan(@get('previews'), width, height)

  previewBetween: (minWidth, minHeight, maxWidth, maxHeight) ->
    Util.previewBetween @get('previews'), arguments...

  biggestPreview: ->
    Util.biggestPreview(@get('previews'))

  smallestPreview: ->
    Util.smallestPreview(@get('previews'))

  getType: -> Util.fileExt(@get 'name') ? @get('mimeType')

  getServiceKey: ->
    if @get('isUpload')
      return 'trello'

    { host } = parseURL @get('url')

    services =
      'docs.google.com': 'gdrive'
      'drive.google.com': 'gdrive'
      'www.dropbox.com': 'dropbox'
      'onedrive.live.com': 'onedrive'
      'app.box.com': 'box'

    return services[host] ? 'other'



// WEBPACK FOOTER //
// ./app/scripts/models/attachment.coffee